const { isServer } = require('../is-server')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {object|element} el
 * @param {string} type
 */
function triggerEvent (el, type) {
  if (isServer() || !el || !type) return

  /* istanbul ignore else: IE specific so we skip these in the tests */
  if ('createEvent' in document && document.createEvent) {
    const e = document.createEvent('HTMLEvents')
    e.initEvent(type, false, true)
    el.dispatchEvent(e)
  } else if ('createEventObject' in document && document.createEventObject) {
    const e = document.createEventObject()
    e.eventType = type
    el.fireEvent('on' + e.eventType, e)
  }
}

module.exports = { triggerEvent }
